import { render } from "./ShowEditBn.vue?vue&type=template&id=3b709e73&ts=true"
import script from "./ShowEditBn.vue?vue&type=script&lang=ts"
export * from "./ShowEditBn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__